export default __webpack_public_path__ + "static/media/mdb.8f154603.svg";